import React from "react"

function AddVideo (props) {
  let date = new Date().getFullYear(),
      uploaded = (date - props.year)
  
  return (
    <div className="video-container">
      <a className="video-thumbnail" href={"https://www.youtube.com/watch?v=" + props.link}>
        <img src={"https://i1.ytimg.com/vi/" + props.link + "/hqdefault.jpg"} alt={"" + props.title} loading="lazy" />
      </a>
      <a className="video-title" href={"https://www.youtube.com/watch?v=" + props.link}><h3>{props.title}</h3></a>
      <p className="video-uploaded">{uploaded === 0 && 'this year'}{uploaded === 1 && uploaded + ' year ago'}{uploaded > 1 && uploaded + ' years ago'}{props.unlisted === "true" && <>&nbsp;|&nbsp;<span className="video-unlisted">unlisted</span></>}</p>
      <hr />
      <p className="video-description">{props.description}</p>
    </div>
  )
}

export default AddVideo